// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-223c5bab]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.sw-update-popup > button[data-v-223c5bab] {\n  margin-top: 0.5em;\n  padding: 0.25em 1.5em;\n}", ""]);
// Exports
module.exports = exports;
